// src/i18n/index.js — synchronous init with bundled resources.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// IT resources
import itCommon from './locales/it/common.json';
import itErrors from './locales/it/errors.json';
import itAuth from './locales/it/auth.json';
import itShell from './locales/it/shell.json';
import itWizard from './locales/it/wizard.json';
import itOutputs from './locales/it/outputs.json';
import itAdmin from './locales/it/admin.json';
import itContext from './locales/it/context.json';
import itDashboard from './locales/it/dashboard.json';
import itCredits from './locales/it/credits.json';
import itBilling from './locales/it/billing.json';
import itOnboarding from './locales/it/onboarding.json';
import itLegal from './locales/it/legal.json';
// EN resources
import enCommon from './locales/en/common.json';
import enErrors from './locales/en/errors.json';
import enAuth from './locales/en/auth.json';
import enShell from './locales/en/shell.json';
import enWizard from './locales/en/wizard.json';
import enOutputs from './locales/en/outputs.json';
import enAdmin from './locales/en/admin.json';
import enContext from './locales/en/context.json';
import enDashboard from './locales/en/dashboard.json';
import enCredits from './locales/en/credits.json';
import enBilling from './locales/en/billing.json';
import enOnboarding from './locales/en/onboarding.json';
import enLegal from './locales/en/legal.json';

export const SUPPORTED_LOCALES = ['it', 'en'];
export const LOCALE_STORAGE_KEY = 'app_locale';

const resources = {
  it: { common: itCommon, errors: itErrors, auth: itAuth, shell: itShell, wizard: itWizard,
        outputs: itOutputs, admin: itAdmin, context: itContext, dashboard: itDashboard, credits: itCredits, billing: itBilling, onboarding: itOnboarding, legal: itLegal },
  en: { common: enCommon, errors: enErrors, auth: enAuth, shell: enShell, wizard: enWizard,
        outputs: enOutputs, admin: enAdmin, context: enContext, dashboard: enDashboard, credits: enCredits, billing: enBilling, onboarding: enOnboarding, legal: enLegal },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    supportedLngs: SUPPORTED_LOCALES,
    ns: ['common', 'errors', 'auth', 'shell', 'wizard', 'outputs', 'admin', 'context', 'dashboard', 'credits', 'billing', 'onboarding', 'legal'],
    defaultNS: 'common',
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      // ⛔ NO automatic cache. With `caches: ['localStorage']` i18next wrote the
      // key on EVERY changeLanguage — including the 'it' fallback at init — so a
      // browser that never chose anything looked as if it had, and
      // seedLocaleFromUser (./locale.js) could never apply the account language.
      // The key is now written ONLY by setLocale, i.e. by an explicit user choice.
      caches: [],
    },
    interpolation: { escapeValue: false }, // React already escapes
    react: { useSuspense: false },
  });

export default i18n;
